import React from 'react'
import '../css/ourceo.css';

const OurCeo = () => {
  return (
    <div className='our-ceo-section'> 
        <h2>Our CEO's</h2>

        <div className="our-ceo-cards">
            <div className="ceo-card">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s" alt="" />
                <h2>Name</h2>
                <h4>Managing Director</h4>
            </div>
            <div className="ceo-card">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s" alt="" />
                <h2>Name</h2>
                <h4>Managing Director</h4>
            </div>
            <div className="ceo-card">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s" alt="" />
                <h2>Name</h2>
                <h4>Managing Director</h4>
            </div>
        </div>
    </div>
  )
}

export default OurCeo
